module.exports = __webpack_public_path__ + "img/007-woman-2.a828024a.svg";